// sliders.js
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export function initHeroSlider() {
    const heroSlider = document.querySelector('.hero-slider');

    if (heroSlider) {
        new Swiper(heroSlider, {
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },

            navigation: {
                nextEl: '.hero-slider .swiper-button-next',
                prevEl: '.hero-slider .swiper-button-prev',
            },
        });
    }
}

export function initProductSlider() {
    const productSwiper = document.querySelector('.js-product-swiper');

    if (productSwiper) {
        new Swiper(productSwiper, {
            loop: false,
            slidesPerView: 3,
            spaceBetween: 25,          // Gap between slides in px
            pagination: {
                el: '.js-product-swiper .swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.js-product-swiper .swiper-button-next',
                prevEl: '.js-product-swiper .swiper-button-prev',
            },
            breakpoints: {
                0: {
                    slidesPerView: 1
                },
                768: {
                    slidesPerView: 2
                },
                1024: {
                    slidesPerView: 3
                }
            }
        });
    }
}

export function initBrandsSlider() {
    const brandsSwiper = document.querySelector('.js-brands-slider');

    if (brandsSwiper) {
        new Swiper(brandsSwiper, {
            loop: true,
            slidesPerView: 4,
            spaceBetween: 89,          // Gap between slides in px
            // centeredSlides: true,
            // navigation: {
            //     nextEl: '.js-brands-slider .swiper-button-next',
            //     prevEl: '.js-brands-slider .swiper-button-prev',
            // },
            speed: 8000, // How long it takes to transition (higher = slower)
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            freeMode: true,
            freeModeMomentum: false,
            grabCursor: false,
            allowTouchMove: false, // Optional: disable dragging to avoid interference
            breakpoints: {
                0: {
                    initialSlide: 0,
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                768: {
                    slidesPerView: 4,
                    initialSlide: 11,
                }
            }
        });
    }
}

export function initSingleProductSlider() {
    const singleSwiper = document.querySelector('.js-single-product-slider');

    if (singleSwiper) {
        new Swiper(singleSwiper, {
            loop: false,
            slidesPerView: 4,
            spaceBetween: 25,          // Gap between slides in px
            navigation: {
                nextEl: '.gallery-container .swiper-button-next',
                prevEl: '.gallery-container .swiper-button-prev',
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
                768: {
                    slidesPerView: 4
                }
            }
        });
    }
}

export function initFreeScrollSlider() {
    const sliders = document.querySelectorAll('.js-gallery-slider');

    sliders.forEach((slider) => {
        new Swiper(slider, {
            slidesPerView: 'auto',
            spaceBetween: 25,
            freeMode: false,
            loop: true,
            initialSlide: 3,
            centerSlides: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },

            breakpoints: {
                0: {
                    slidesPerView: 2,
                    spaceBetween: 25,
                },
                768: {
                    slidesPerView: 'auto'
                }
            }

        });
    });
}
